/**
 * Created by tofael on 11/9/17.
 */
import React from 'react';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import {white} from 'material-ui/styles/colors';
import FileUpload from './file-upload/';
import PrescriptionUpload from './file-upload/prescription-upload';
import MissionViewContainer from '../../containers/mission-view';

const styles = {
  root: {

  },
  customContentStyle: {
    width: '100%',
    height: '100%',
    maxWidth: 'none',
    maxHeight: 'none'
  },
  container: {

  },
  box: {
    overflow:'scroll',
    width : '100%',
    height:'90%'
  },
  button: {
    height: '45px',
    width: '200px'
  },
};

const MissionDetailDialog = (props) => {
  let {
    open, review, reviewDialogOpen, mission, onChange, comment, endMissionDialogOpen, reopenMissionDialogOpen,
    endMission, reopenMission, toggleEndMissionDialog, toggleReopenMissionDialog, toggleMissionDetailDialog,
    style, className, toggleReviewDialog, toggleTestMissionFlag, submitReview, uploadReport, uploadPrescription, 
    deleteReport, startInvestigation, endInvestigation
  } = props;

  const actions = [
    <FileUpload
      label="Upload Report"
      style={{marginRight:'10px'}}
      onSubmit={uploadReport} />,

    <PrescriptionUpload
      label="Upload Prescription"
      style={{marginRight:'10px'}}
      onSubmit={uploadPrescription} />,

    <RaisedButton
      labelColor={white}
      label="Review Mission"
      style={{marginRight:'10px'}}
      backgroundColor='#D02504'
      onClick={toggleReviewDialog} />,

    <RaisedButton
      labelColor={white}
      label={mission && mission.test ? 'Unmark Test' : 'Mark As Test Mission'}
      style={{marginRight:'10px'}}
      backgroundColor='#D02504'
      onClick={toggleTestMissionFlag.bind(null,mission)} />
  ];

  if(mission && mission.status === "dispatched") {
    actions.push(
      <RaisedButton
      labelColor={white}
      label="Start Investigation"
      style={{marginRight:'10px'}}
      backgroundColor='#14A46E'
      onClick={startInvestigation} />
    )
  }

  if(mission && mission.status === "investigating") {
    actions.push(
      <RaisedButton
      labelColor={white}
      label="End Investigation"
      style={{marginRight:'10px'}}
      backgroundColor='#D02504'
      onClick={endInvestigation} />
    )
  }
  if (mission && !mission.active) {
    actions.push(
      <RaisedButton
        labelColor={white}
        label="Re Open Mission"
        backgroundColor='#14A46E'
        onClick={toggleReopenMissionDialog.bind(null,mission)} />
    )
  } else {
    actions.push(
      <RaisedButton
        labelColor={white}
        label="End Mission"
        backgroundColor='#D02504'
        onClick={toggleEndMissionDialog.bind(null,mission)} />
    )
  }
  return (
    <div className={className || 'prescription__dialog'} style={{...styles.root, ...style}}>
      <Dialog
        modal={false}
        open={open}
        actions={actions}
        autoScrollBodyContent={true}
        onRequestClose={toggleMissionDetailDialog}
        contentStyle={styles.customContentStyle} >

        <MissionViewContainer
          mission={mission}
          comment={comment}
          review={review}
          submitReview={submitReview}
          toggleReviewDialog={toggleReviewDialog}
          reopenMission={reopenMission}
          endMission={endMission}
          onChange={onChange}
          deleteReport={deleteReport}
          reviewDialogOpen={reviewDialogOpen}
          endMissionDialogOpen={endMissionDialogOpen}
          reopenMissionDialogOpen={reopenMissionDialogOpen}
          toggleEndMissionDialog={toggleEndMissionDialog}
          toggleReopenMissionDialog={toggleReopenMissionDialog}
        />
      </Dialog>
    </div>
  );
};

export default MissionDetailDialog;


// WEBPACK FOOTER //
// ./src/screens/shared/mission-detail-dialog.js